/* eslint-disable react/prop-types */
import Modal from "@/common/elements/Modal";
import CommonReportActionHeader from "../CommonReport/CommonReportActionHeader";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import deptBadge from "@/assets/Dept_Badge.png";
import {
  StyledReportContainer,
  StyledReportContent,
} from "../CommonReport/styles";
import { useSelector } from "react-redux";
import { getRefListNameByID } from "@/util/common_function";
import { PHOTOS_BASE_URL } from "@/util/api";
import exportComponentAsPDF from "@/util/export_file";
import { useRef } from "react";

// data (optional) is the specific record being viewed — e.g. Transport's own
// `data` prop — so this report shows that record's inmate instead of
// whatever happens to be loaded in the Bookings redux slice. Transport can
// be opened independently of any open Booking (search grid, "Search by ID",
// etc), so it must always pass `data` rather than relying on the fallback.
// Callers that open this from within an actual Booking context (House
// Tracking, Inmate Movement) don't pass `data` and keep using the
// globally-loaded booking, matching their pre-existing behavior.
const TransportDocumentModal = ({ show = false, onHide, data }) => {
  const bookingsRedux = useSelector((state) => state?.bookings?.bookings);
  const bio = data?.bio?.[0] ?? bookingsRedux?.bio?.[0];
  const reportRef = useRef();

  const getFinalPath = (path) => {
    if (path?.includes("\\")) {
      const splitPath = path?.split("/");
      if (splitPath?.length === 4) {
        splitPath.shift();
        splitPath.shift();
      }

      return splitPath?.join("\\");
    }
    return path;
  };

  const photoPath = bio?.bioPhotos?.[0]?.photos?.[0]?.fullSizePath;

  const handleExportClick = () => {
    exportComponentAsPDF(reportRef, "housetrack-transport-docs.pdf");
  };

  const handlePrintClick = () => {};

  return (
    <>
      <Modal header="IMATS Report" show={show} onHide={onHide} size="xl">
        <CommonReportActionHeader
          onClose={onHide}
          onExportClick={handleExportClick}
          handlePrintClick={handlePrintClick}
        />

        <StyledReportContainer ref={reportRef}>
          <StyledReportContent>
            <StyledGridRow>
              <StyledGridCol xs={24}>
                <StyledFlex justify="space-between" marginTop="20px">
                  <div>
                    <img
                      src={deptBadge}
                      alt="log here"
                      style={{ maxWidth: "120px" }}
                    />
                  </div>
                  <div style={{ textAlign: "center", flexGrow: "1" }}>
                    <div className="report-subtle-tile">
                      IMATS - Transport Report
                    </div>
                    <div className="report-primary-tile">
                      ANOKA COUNTY COMMUNITY CORRECTIONS <br /> ANOKA, MN
                    </div>
                  </div>
                </StyledFlex>
              </StyledGridCol>
            </StyledGridRow>

            <StyledSectionHeading>
              <span>PERSONAL INFORMATION</span>
            </StyledSectionHeading>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={20}>
                <div className="report-flex-item">
                  <div className="key-value">{`${bio?.lName || ""}, ${bio?.fName || ""}`}</div>
                </div>

                <StyledGridRow gutter={16}>
                  <StyledGridCol xs={12}>
                    <div className="report-flex-item">
                      <label className="key-title">Race:</label>
                      <div className="key-value">{bio?.race || ""}</div>
                    </div>
                    <div className="report-flex-item">
                      <label className="key-title">From Location:</label>
                      <div className="key-value">
                        {data?.fromLocation || ""}
                      </div>
                    </div>
                    <div className="report-flex-item">
                      <label className="key-title">Start Date:</label>
                      <div className="key-value">
                        {data?.startDate
                          ? `${data.startDate} ${data.startTime || ""}`
                          : ""}
                      </div>
                    </div>
                    <div className="report-flex-item">
                      <label className="key-title">Start Mileage:</label>
                      <div className="key-value">
                        {data?.startMileage || ""}
                      </div>
                    </div>
                    <div className="report-flex-item">
                      <label className="key-title">Transport Officer:</label>
                      <div className="key-value">
                        {getRefListNameByID(
                          "",
                          data?.transportOfficerStaffID,
                          true,
                          true,
                        ) || ""}
                      </div>
                    </div>
                  </StyledGridCol>

                  <StyledGridCol xs={12}>
                    <div className="report-flex-item">
                      <label className="key-title">Sex:</label>
                      <div className="key-value">{bio?.sex || ""}</div>
                    </div>
                    <div className="report-flex-item">
                      <label className="key-title">To Location:</label>
                      <div className="key-value">{data?.toLocation || ""}</div>
                    </div>
                    <div className="report-flex-item">
                      <label className="key-title">End Date:</label>
                      <div className="key-value">
                        {data?.endDate
                          ? `${data.endDate} ${data.endTime || ""}`
                          : ""}
                      </div>
                    </div>
                    <div className="report-flex-item">
                      <label className="key-title">End Mileage:</label>
                      <div className="key-value">{data?.endMileage || ""}</div>
                    </div>
                    <div className="report-flex-item">
                      <label className="key-title">Transport Reason:</label>
                      <div className="key-value">{data?.moveReason || ""}</div>
                    </div>
                  </StyledGridCol>
                </StyledGridRow>

                <div className="report-flex-item">
                  <label className="key-title">DOB:</label>
                  <div className="key-value">{bio?.dob || ""}</div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Transport Status:</label>
                  <div className="key-value">{data?.transportStatus || ""}</div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Scheduled Start Date:</label>
                  <div className="key-value">
                    {data?.scheduledDate
                      ? `${data.scheduledDate} ${data.scheduledTime || ""}`
                      : ""}
                  </div>
                </div>
                <div className="report-flex-item">
                  <label className="key-title">Comments:</label>
                </div>
                <div className="report-flex-item">
                  <div className="key-value">{data?.comments || ""}</div>
                </div>
              </StyledGridCol>

              <StyledGridCol xs={4}>
                <div className="report-profile-img">
                  {photoPath ? (
                    <div className="report-no-image">
                      <img
                        src={PHOTOS_BASE_URL + getFinalPath(photoPath)}
                        alt={"No Image"}
                      />
                    </div>
                  ) : (
                    <div className="report-no-image">No Picture</div>
                  )}
                </div>
              </StyledGridCol>
            </StyledGridRow>

            <StyledGridRow
              style={{ marginBottom: "20px", marginTop: "20px" }}
              gutter={20}
            >
              <StyledGridCol span={5}>
                <div className="sign-form-check">
                  Transporting Officer - print{" "}
                </div>
                <div className="sign-form-check">Receiving Officer - print</div>
              </StyledGridCol>
              <StyledGridCol span={5}>
                <div className="sign-form-check"> Signature </div>
                <div className="sign-form-check">Signature</div>
              </StyledGridCol>
              <StyledGridCol span={4}>
                <div className="sign-form-check">Beg. Mileage</div>
                <div className="sign-form-check"> End. Mileage</div>
              </StyledGridCol>
              <StyledGridCol span={3}>
                <div className="sign-form-check"> Date </div>
                <div className="sign-form-check"> Date </div>
              </StyledGridCol>
              <StyledGridCol span={3}>
                <div className="sign-form-check">Time</div>
                <div className="sign-form-check"> Time</div>
              </StyledGridCol>
            </StyledGridRow>
          </StyledReportContent>
        </StyledReportContainer>
      </Modal>
    </>
  );
};
export default TransportDocumentModal;
